import React from "react";
import './index.scss';

const NoChartData = (
    {
        className = '',
    }
) => {
    return (
        <>
            <div className={`no-chart-data d-flex align-items-center justify-content-center h-100 ${className}`}>
                No data
            </div>
        </>
    );
}
export default NoChartData;
